import { render } from "./top-list.vue?vue&type=template&id=0853391c&ts=true"
import script from "./top-list.ts?vue&type=script&lang=ts"
export * from "./top-list.ts?vue&type=script&lang=ts"

import "./top-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__